module.exports = __webpack_public_path__ + "static/media/Smoke.bb63c876.png";